import { request } from '@/utils/request'

export const selectApi = {
  users: data => request.get('users/selector', data),
}
